import _ from 'lodash';

import ModalActions from '../actions/ModalActions';
import InAppStore from '../stores/InAppStore';
import InAppVersionEndingModal from '../components/inApp/InAppVersionEndingModal';

export const openInAppVersionEndingModal = () => {
    if (!InAppStore.isInApp()) {
        return;
    }
    _.defer(() => ModalActions.open(InAppVersionEndingModal));
};
